export enum EventType {
  CLEAR_FORM = 'CLEAR_FORM',
  SCROLL_TO_TOP = 'SCROLL_TO_TOP'
}
